import React, { useMemo } from "react";

import { getActiveToken, getEnvironment, useUserContext } from "utils";

const env = getEnvironment();

const COPILOT_URL = env.production ? "https://regag.klim.eco/" : "https://regag-dev.klim.eco/";

export const CopilotPage = () => {
  const { user } = useUserContext();

  const iframeSrc = useMemo(() => {
    const token = getActiveToken();
    if (token) {
      const url = new URL(COPILOT_URL);
      url.searchParams.set("token", token);
      if (user?.email) {
        url.searchParams.set("email", user.email);
      }
      if (user?.language) {
        url.searchParams.set("language", user.language);
      }
      return url.toString();
    }
    return COPILOT_URL;
  }, [user?.email, user?.language]);

  // ph-no-capture: session replay would otherwise record the src, with the user's token and email in it.
  return (
    <iframe
      id="copilot-fe"
      className="ph-no-capture"
      style={{ width: "100%", height: "100%", border: 0, display: "block" }}
      src={iframeSrc}
      title="RegAg Copilot"
    />
  );
};
